import { Cpu, FileStack, Zap, Wrench, GitBranch, Shield } from 'lucide-react';
import { Card } from './ui/Card';
import './Features.css';

const FEATURES = [
  {
    icon: <Cpu />,
    title: 'AI-Powered Analysis',
    description:
      'The first MCP server for EDA netlists. Enables AI assistants to understand and query your circuit designs.',
  },
  {
    icon: <FileStack />,
    title: 'Multi-Format Support',
    description:
      'Works with Cadence (CIS, HDL) and Altium Designer projects. Parses schematics and netlists natively.',
  },
  {
    icon: <Zap />,
    title: 'Zero Configuration',
    description:
      'Pre-compiled binaries for macOS, Linux, and Windows. Download, configure your MCP client, and start querying.',
  },
  {
    icon: <Wrench />,
    title: 'Faster Reviews',
    description:
      'Gives the agent the context it needs to flag risks early and keep reviews focused.',
  },
  {
    icon: <GitBranch />,
    title: 'Design-Wide Context',
    description: 'Strengthens design review accuracy by linking context across the entire circuit.',
  },
  {
    icon: <Shield />,
    title: 'Review Confidence',
    description: 'Turns raw design data into clear, actionable review decisions you can build on.',
  },
];

/**
 * Features section showcasing key product capabilities.
 */
export function Features() {
  return (
    <section id="features" className="section features">
      <div className="container">
        <header className="section-header">
          <h2>
            Built for <span className="gradient-text">Hardware Engineers</span>
          </h2>
          <p>Everything you need to query and understand circuit designs using AI.</p>
        </header>

        <div className="features-grid">
          {FEATURES.map((feature, index) => (
            <Card
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              className="features-card"
              style={{ animationDelay: `${index * 100}ms` }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
